'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UITextInput from 'UIComponents/input/UITextInput';
export default class SidebarInput extends Component {
  render() {
    const _this$props = this.props,
          {
      className,
      inputComponent: Input,
      wrap
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["className", "inputComponent", "wrap"]);

    const inputClassName = classNames('sidebar-input', className);

    if (wrap) {
      return /*#__PURE__*/_jsx("span", {
        className: inputClassName,
        children: /*#__PURE__*/_jsx(Input, Object.assign({}, rest))
      });
    }

    return /*#__PURE__*/_jsx(Input, Object.assign({}, rest, {
      className: inputClassName
    }));
  }

}
SidebarInput.propTypes = {
  className: PropTypes.string,
  inputComponent: PropTypes.elementType,
  wrap: PropTypes.bool
};
SidebarInput.defaultProps = {
  className: null,
  inputComponent: UITextInput,
  wrap: false
};